import CapRulesCell from './CapRulesCell'
import PtoRulesMixin from './PtoRulesMixin'

class PtoCapRulesCell extends CapRulesCell {
    constructor() {
        super()
        this.mixin = new PtoRulesMixin()
    }
}

export default PtoCapRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PtoCapRulesCell.js